// vuex
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)


var state={
    privilege:[],
    user_info:{},
    web_token:'',
    url:'http://pm.whadshel.com'
}

var mutations={

}

const store = new Vuex.Store({
    state,
    mutations
})

export default store;


// WEBPACK FOOTER //
// ./src/vuex/store.js